"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url-search-params.js");

var _react = require("react");

var _antd = require("antd");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Hook to retrieve the results from the
 * <a href="https://nominatim.org/release-docs/latest/api/Search/">
 *  Nominatim Geocoder
 * </a>
 * 
 */
var useNominatimGeocoder = function useNominatimGeocoder() {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      places = _useState4[0],
      setPlaces = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      timeoutId = _useState6[0],
      setTimeoutId = _useState6[1];

  var clearRequest = (0, _react.useCallback)(function () {
    setError(null);
    setPlaces(null);
  }, []);
  var doFetch = (0, _react.useCallback)(function (url, fetchOpts) {
    clearRequest();
    fetch(url, fetchOpts).then(function (response) {
      if (!response.ok) {
        throw new Error(response);
      }

      return response.json();
    }).then(function (responseData) {
      var features = responseData.features;
      var places = [];

      if (features && features.length > 0) {
        places = features.map(function (feature) {
          return {
            label: feature.properties.display_name,
            value: feature.properties.place_id.toString(),
            feature: feature
          };
        });
      }

      places.reverse();
      setPlaces(places);
    }).catch(function (error) {
      _antd.message.info(error.message);

      setError(error);
    });
  }, [clearRequest]);
  var sendRequest = (0, _react.useCallback)(function (value) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var fetchOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      method: 'GET',
      format: 'json'
    };
    var url = 'https://nominatim.openstreetmap.org/search?' + new URLSearchParams({
      q: value ? value : undefined,
      format: 'geojson'
    });
    var newTimeoutId = setTimeout(function () {
      doFetch(url, fetchOpts);
    }, delay);
    setTimeoutId(newTimeoutId);
  }, [doFetch]);
  return [sendRequest, clearRequest, places, timeoutId, error];
};

var _default = useNominatimGeocoder;
exports.default = _default;